// Translate known backend error messages for the bank, mileage and payout features; unknown ones pass through.
const KNOWN = [
  ['Dates must be YYYY-MM-DD', 'apiErrors.dateFormat'],
  ['Date must be YYYY-MM-DD', 'apiErrors.dateFormat'],
  ['Month must be YYYY-MM', 'apiErrors.monthFormat'],
  ['The file is empty or larger than 15 MB', 'apiErrors.fileSize'],
  ['Could not read this statement', 'apiErrors.unreadable'],
  ['No transactions found in this file', 'apiErrors.noTransactions'],
  ['Transaction not found', 'apiErrors.txNotFound'],
  ['Unknown record type', 'apiErrors.unknownType'],
  ['Already linked', 'apiErrors.alreadyLinked'],
  ['That record is no longer available to link', 'apiErrors.recordGone'],
  ['Link not found', 'apiErrors.linkNotFound'],
  ['Unlink the records first', 'apiErrors.unlinkFirst'],
  ['Refund not found', 'apiErrors.refundNotFound'],
  ['This refund is already settled', 'apiErrors.refundSettled'],
  ['Template not found', 'apiErrors.templateNotFound'],
  ['No projects found', 'apiErrors.noProjects'],
  ['Could not find a header row', 'apiErrors.noHeader'],
  ['Enter a supplier name or NIP', 'apiErrors.supplierNameOrNip'],
  ['This supplier is already on the list', 'apiErrors.supplierExists'],
  ['Supplier not found', 'apiErrors.supplierNotFound'],
  ['Invalid account number', 'apiErrors.invalidAccount'],
  ['Add at least one keyword or a counterparty account', 'apiErrors.ruleNeedsMatch'],
  ['Choose the project the fees are booked to', 'apiErrors.ruleProject'],
  ['Choose an expense category', 'apiErrors.ruleCategory'],
  ['Rule not found', 'apiErrors.ruleNotFound'],
  ['Invoice not found', 'apiErrors.invoiceNotFound'],
  ['Only PDF, Word, text and image files can be attached', 'apiErrors.tplFileType'],
  ['The file is empty or larger than 15 MB', 'apiErrors.fileSize'],
  ['This invoice is not open for payment', 'apiErrors.invoiceNotOpen'],
  ['Invalid email address', 'apiErrors.invalidEmail'],
  ['Recipient email is required', 'apiErrors.recipientRequired'],
  ['SMTP not configured', 'apiErrors.smtpMissing'],
  ['SMTP error', 'apiErrors.smtpError'],
  ['Email sending error', 'apiErrors.smtpError'],
  ['PDF generation error', 'apiErrors.pdfError'],
];

export const apiErrorText = (err, t, fallbackKey) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail !== 'string' || !detail) return t(fallbackKey);
  const hit = KNOWN.find(([en]) => detail.startsWith(en));
  if (!hit) return detail;
  const extra = detail.slice(hit[0].length).replace(/^:\s*/, '');
  if (!extra || !['apiErrors.unreadable', 'apiErrors.invalidEmail'].includes(hit[1])) return t(hit[1]);
  const sub = KNOWN.find(([en]) => extra.startsWith(en));
  return `${t(hit[1])}: ${sub ? t(sub[1]) : extra}`;
};
